export enum PaymentTermsType {
  OnReception = 1,
  EndOfMonth = 2,
  Days10 = 3,
  Days30 = 4,
  Days30AfterMonthEnd = 5,
  Days45 = 6,
  Days45AfterMonthEnd = 7,
  Days60 = 8,
  Days60AfterMonthEnd = 9,
  Days90 = 10,
  Days90AfterMonthEnd = 11,
  Days120 = 12,
  Other = 100
}

export enum PaymentMethodType {
  None = 0,
  Payout = 1,
  PayoutSepa = 2,
  PaymentCard = 4,
  Check = 5,
  Cash = 6,
}

export enum LatePaymentInterestType {
  None = 1,
  MonthPercent1 = 2,
  MonthPercent1_5 = 3,
  MonthPercent2 = 4,
  Custom = 100,
}
